import {Button, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {MiscPrice} from "../../../../api/MiscPricing";
import {first, useAsyncAction} from "nate-react-api-helpers";
import React, {useState} from "react";
import {AutoComplete} from "../../shopdrawing/openings/AutoComplete";
import {Company, CompanyKind} from "../../../../api/Companies";
import {useGetAll} from "../../../logistics/routes/useGetAll";
import {api} from "../../../../api/API";
import {useNavigate} from "react-router-dom";

export function CreatePoDialog(props: {
    onClose(): void;
    onUpdate(): void;
    row: MiscPrice;
}) {
    const companies = useGetAll(props => api.companies.list(props), {
        kind: "supplier" as CompanyKind
    }, []);

    const [value, setValue] = useState<number>();
    const list = companies.asList || [];

    const nav =  useNavigate();
    const update = useAsyncAction(async (input) => {
        const obj = await api.miscPricing.createPoForItem(input);
        nav(`/logistics/purchasing/${obj.id}`);
    }, []);

    const submit = () => {
        if(!value) return;
        update.callback({
            id: props.row.id,
            supplier: value,
        })
    };

    return (
        <Dialog2 open onClose={props.onClose} onEnterPress={submit}>
            <DialogTitle>
                Create PO for {props.row.name}
            </DialogTitle>
            <DialogContent>
                <div style={{height: 4}}/>
                <AutoComplete<Company>
                    style={{minWidth: 350}}
                    label="Supplier"
                    value={first(list, l => l.id === value)}
                    onSelect={v => {
                        setValue(v.id);
                    }}
                    equals={(a, b) => a.id === b.id}
                    makeLabel={a => a.name}
                    search={async search => {
                        return list.filter(v => v.name.toLowerCase().indexOf(search.toLowerCase()) === 0);
                    }}
                    fullWidth
                />
            </DialogContent>
            <DialogActions>
                {update.LoadingElement}
                <Button onClick={props.onClose}>Cancel</Button>
                <Button variant="contained" disabled={!value} onClick={submit}>Create</Button>
            </DialogActions>
        </Dialog2>
    )
}